const LikeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={22}
      fill="none"
      viewBox="0 0 26 22"
    >
      <path d="M7.6 1C3.955 1 1 3.86955 1 7.40914C1 13.8183 8.8 19.6448 13 21C17.2 19.6448 25 13.8183 25 7.40914C25 3.86955 22.045 1 18.4 1C16.168 1 14.194 2.07615 13 3.7233C12.3914 2.88149 11.5829 2.19448 10.6429 1.72044C9.70294 1.24639 8.65918 0.999274 7.6 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default LikeIcon;
